<template>
  <transition name="fade">

    <div>

      <!--
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false, -->

      <gmap-map
        ref="map"
        :center="center"
        :zoom="zoom"
        @click="clicked"
        :options="{
          mapTypeControl: false,
          zoomControl: true,
          fullscreenControl: true,
          disableDefaultUi: false,
          streetViewControl: false,
        }"
        :style="{'width': '100%;', 'height':height}"
      >
      <!-- style="width: 100%; height: 400px" -->

        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false"
        >
        <div v-html="infoContent"></div>
          <!-- {{infoContent}} -->
        </gmap-info-window>

        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :label="m.label"
          :title="m.title"
          :animation="m.animation"
          @click="center = m.position, toggleInfoWindow(m,index)"

        ></gmap-marker>
        <gmap-circle
          :key="m.id"
          v-for="(m) in markers"
          :center="m.position"
          :radius="200"
          :visible="true"
          :options="{strokeWeight: 0.1, fillOpacity: 0.2}"
        ></gmap-circle>
        <!--   :animation="google.maps.Animation.DROP" -->

      <!--  :clickable="true" :draggable="true"  @drag="getMove" -->

      </gmap-map>

    </div>

  </transition>
</template>

<script>

const mapMarker =  require('@/assets/img/marker.svg');

export default {
  name: "MapParkingPosition",
  props: {
    coordsParent: { type: Object },
    markersParent: { type: Array, default() { return []}},
    height: { type: String, default: '600px'}
  },

  data() {
    return {
      // default values
      center: { lat: 38.3451859, lng: -0.4827559 },
      zoom: 16,
      markers: [],
      marker: {},

      iconBase:
          "https://developers.google.com/maps/documentation/javascript/examples/full/images/",
      icons:{
          parking: {
            icon: this.iconBase + "parking_lot_maps.png",
          },
          library: {
            icon: this.iconBase + "library_maps.png",
          },
          info: {
            icon: this.iconBase + "info-i_maps.png",
          },
      },

      markerOptions: {
        url: mapMarker,
        size: {width: 60, height: 60, f: 'px', b: 'px',},
        scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
      },

      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },

      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,


    };
  },
  mounted() {
    if (this.coordsParent && this.coordsParent.lat) {

      const marker = {
        lat: this.coordsParent.lat,
        lng:  this.coordsParent.lng,
      };
      this.center = marker;

      this.markers = [
        ...this.markersParent
      ]
    }
    // else {
    //   // this.geolocate();
    // }
  },
  created() {

  },
  computed: {

  },
  watch: {
    markers(markers) {
      // console.log(markers);
    },
    coordsParent(coords) {
      this.center = {
        lat: coords.lat,
        lng:  coords.lng,
      };
            const marker = {
        lat: this.coordsParent.lat,
        lng:  this.coordsParent.lng,
      };
      this.center = marker;

      this.markers = [
        ...this.markersParent
      ]

    }
  },
  methods: {
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    clicked(coords) {

      this.center = {
        lat: coords.latLng.lat(),
        lng: coords.latLng.lng(),
      }
    },
    cancelled() {
      this.$emit("cancelled", true);
    },
    getMove(coords){
      const marker = {
        lat: coords.latLng.lat(),
        lng: coords.latLng.lng(),
      };
      this.marker.position = marker;
    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }

  },
};
</script>

<style lang="scss" scoped>
agm-map,
gmap-map{
  height: 100%;
}

.shadowOutline {
  text-shadow: 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white, 0 0 4px white;
}

</style>
